<div *ngIf="partner === 'alyafi ip group'">
  <app-generic-partner-dashboard-nc></app-generic-partner-dashboard-nc>
</div>

<div *ngIf="partner === 'medco'">
  <app-generic-partner-dashboard-medco
    [wallets]="PARTNER_WALLETS"
  ></app-generic-partner-dashboard-medco>
</div>

<div
  *ngIf="
    partner === 'nextcare' ||
    partner === 'ignitia' ||
    partner === 'ruya advisory' ||
    partner === 'xpertvia l l c'
  "
>
  <app-generic-partner-dashboard-nc
    [wallets]="PARTNER_WALLETS"
    [depositLabel]="depositLabel"
    [URL_CASH_OUT]="URL_CASH_OUT"
    [URL_USERS_COUNT]="URL_USERS_COUNT"
    [DEPOSITS_AMOUNT]="DEPOSITS_AMOUNT"
    [TOTAL_FUNDS]="TOTAL_FUNDS"
  ></app-generic-partner-dashboard-nc>
</div>

<!-- other partners  -->
<div *ngIf="partner === 'cci france liban' || partner === 'lebanese red cross'">
  <div class="container-fluid merchants pt-5">
    <div class="card">
      <div class="card-body compliance-card-body">
        <div class="col-12 datetime d-flex justify-content-between">
          <div class-="col-6"></div>
          <div class-="col-6">
            <app-purple-date-picker
              [filter]="filterValue"
              (selectedRangeValueChange)="onDateSelection($event)"
            >
            </app-purple-date-picker>
          </div>
        </div>
        <div class="col-12 p-0 mt-3">
          <div class="d-flex justify-content-between">
            <div class="col-md-6 col-lg-6">
              <span class="dashboardHeader">{{ DASHBOARD_HEADER }}</span>
              <div class="pie-title">
                <div class="chart-container">
                  <ngx-charts-pie-chart
                    [view]="view"
                    [scheme]="colorScheme"
                    [results]="DEPOSITS_AMOUNT"
                    [doughnut]="true"
                    class="hide-tooltip"
                  >
                  </ngx-charts-pie-chart>
                  <div class="center-text">
                    <div class="text-style text-center">{{ depositLabel }}</div>
                    <div class="text-value text-center">
                      ${{ TOTAL_FUNDS | number: "1.2-2" }}
                    </div>
                  </div>
                </div>
                <div>
                  <div *ngFor="let col of DEPOSITS_AMOUNT" class="mb-2">
                    <div class="graphDetails">
                      <img src="{{ col.image }}" />
                      <div class="ml-2">
                        <div class="text-label mb-0">{{ col.name }}</div>
                        <div class="text-label-value">
                          {{ col.currency }}
                          {{ col.value | number: "1.2-2" }} ({{
                            col?.percent
                          }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="graphDetails"
                    *ngIf="user?.partner?.type === 'corporate'"
                  >
                    <img src="./assets/images/svg/rejected.svg" />
                    <div class="ml-2">
                      <div class="text-label mb-0">Cash out completed</div>
                      <div class="text-label-value">
                        <!-- $ {{ CASH_OUT_COMPLETED | number : "1.2-2" }} -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-md-6 col-lg-6"
              *ngIf="user?.partner?.type === 'ngo'"
            >
              <span class="dashboardHeader">Users</span>
              <div class="pie-title">
                <div class="chart-container">
                  <ngx-charts-pie-chart
                    [view]="view"
                    [scheme]="colorUsers"
                    [results]="users"
                    [doughnut]="true"
                    class="hide-tooltip"
                  >
                  </ngx-charts-pie-chart>
                  <div class="center-text">
                    <div class="text-style text-center">Total registered</div>
                    <div class="text-value text-center">
                      {{ userStatDetails?.total_registered?.value }}
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content">
                  <div class="graphDetails">
                    <img src="./assets/images/svg/deposits.svg" />
                    <div class="ml-2">
                      <div class="text-label mb-0">Total onboarded</div>
                      <div class="text-label-value">
                        {{ userStatDetails?.total_onboarded?.value }} ({{
                          userStatDetails?.total_onboarded?.percent
                        }}%)
                      </div>
                    </div>
                  </div>
                  <div class="graphDetails">
                    <img src="./assets/images/svg/rejected.svg" />
                    <div class="ml-2">
                      <div class="text-label mb-0">Total pending</div>
                      <div class="text-label-value">
                        {{ userStatDetails?.total_pending?.value }} ({{
                          userStatDetails?.total_pending?.percent
                        }}%)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TOP LOCATIONS -->
        <div class="col-12 p-0 mt-4" *ngIf="user?.partner?.type === 'ngo'">
          <app-top-cashouts></app-top-cashouts>
        </div>
        <!-- TOP_ITEMS -->
        <div class="col-12 p-0 mt-4" *ngIf="user?.partner?.type === 'merchant'">
          <app-top-items></app-top-items>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="partner !== 'alyafi ip group' && partner !== 'medco'">
  <div
    class="container-fluid merchants pt-5"
    *ngIf="user?.partner?.type !== 'corporate'"
  > -->

<!-- LBP -->
<!-- <div class="pie-title" *ngIf="funds !== '0.00'">
                <div class="chart-container">
                  <ngx-charts-pie-chart
                    [view]="view"
                    [scheme]="colorDeposits"
                    [results]="deposits"
                    [doughnut]="true"
                    class="hide-tooltip"
                  >
                  </ngx-charts-pie-chart>
                  <div class="center-text">
                    <div class="text-style text-center">Total funds</div>
                    <div class="text-value text-center">
                      ${{ funds | number : "1.2-2" }}
                    </div>
                  </div>
                </div>
                <div>
                  <div *ngFor="let col of deposits" class="mb-2">
                    <div class="graphDetails">
                      <img src="{{ col.image }}" />
                      <div class="ml-2">
                        <div class="text-label mb-0">{{ col.name }}</div>
                        <div class="text-label-value">
                          {{ col.currency }}
                          {{ col.value | number : "1.2-2" }} ({{
                            col?.percent
                          }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
